module.exports = __webpack_public_path__ + "images/feature/20171212-6f2013a263a9b5cc60be91971528c858.jpg";